import { useFormikContext } from 'formik'
import { BaseInputWrapperProps } from '~/@/components/inputs/base/types'
import { Dropdown } from '~/@/components/inputs/selection/dropdown'
import { buildEnumDropdownOptions } from '~/components/shared/enum-options'
import { RecordCellEditOrigin } from '../../../table-cells/useEditableTableCellOriginProvider'
import { useRecordDetailsCellPermissions } from '../../RecordDetailsCellPermissionsProvider'
import { AddRecordFormCell, RecordDetailTableCell } from '../../types'

interface EnumArrayCellDetailsProps {
  fieldName: string
  cell: RecordDetailTableCell | AddRecordFormCell
  enableAutofocus: boolean
  value: string[]
  error?: boolean
  columnWidth?: number
  origin?: RecordCellEditOrigin | null
  inputWrapperProps?: BaseInputWrapperProps
}

/**
 * Renders record cell details for a column of type ARRAY with inner type Enum
 */
export function EnumArrayCellDetails({
  fieldName,
  cell,
  value,
  origin,
  inputWrapperProps,
}: EnumArrayCellDetailsProps) {
  const formik = useFormikContext<Record<string, string[] | string | null>>()

  const { isReadOnly } = useRecordDetailsCellPermissions()
  const isInTableCellPopup = origin === RecordCellEditOrigin.TABLE_DETAILS

  return (
    <Dropdown
      className={isInTableCellPopup ? 'max-w-[400px]' : undefined}
      disabled={isReadOnly}
      isMultiSelect
      onChange={(selectedValues) => {
        formik.setFieldTouched(fieldName, true)
        formik.setFieldValue(fieldName, selectedValues)
      }}
      options={buildEnumDropdownOptions(cell.column.enumSet?.options)}
      placeholder={cell.column.name}
      values={value}
      {...inputWrapperProps}
    />
  )
}
